export var JSON_MIME = "application/json";
export var CONTENT_TYPE_HEADER = "Content-Type";
export var FETCH_ERROR = Symbol();
export var CATCHER_FALLBACK = Symbol();